import * as types from 'constants/actionTypes'

export const receiveReferences = (references) => ({ type: types.RECEIVE_REFERENCES, references })



// WEBPACK FOOTER //
// ./src/actions/referencesAC.js